export default __webpack_public_path__ + "static/media/JobSix2.aa762647.jpg";